import { ActivationCodesRepository } from 'common/repositories/index';

/**
 * Activation codes Processor - activation codes sorted by state of subscription and expiration date
 */

let processedActivationCodes = [];
const observableProcessedActivationCodes = new Rx.BehaviorSubject(processedActivationCodes);
const { primeAppIds } = CWCONFIG || [];
/**
 * Sort activation codes by state of the subscription and expiration date
 * @param {Array} data
 */
function sortActivationCodes(currentActivationCodeInArray, nextActivationCodeInArray) {

    // check if both subscriptions are on or off
    if (
        currentActivationCodeInArray.attributes.subscription ===
        nextActivationCodeInArray.attributes.subscription
    ) {

        // check the expiration date of the subscriptions
        if (
            moment(currentActivationCodeInArray.attributes.date_expire) >=
            moment(nextActivationCodeInArray.attributes.date_expire)
        ) {

            return 1;

        }

        // second subscription has a greater expiration date
        return -1;

    }

    // check if first subscription is off
    if (currentActivationCodeInArray.attributes.subscription === 0) {

        return -1;

    }

    // second subscription is off
    return 1;

}
/**
* @ngdoc service
* @name processors.ActivationCodesProcessor
*
* @description
* This class is used to process activation codes.
*/
const ActivationCodesProcessor = {

    /**
     * Replace all activation codes with received data
     * @param {Array} data
     */
    onNext(data) {

        processedActivationCodes = [];
        const sortedActivationCodes = data.sort(sortActivationCodes);
        processedActivationCodes = sortedActivationCodes.sort(this.sortPrimeFirst);
        observableProcessedActivationCodes.onNext(processedActivationCodes);

    },
    sortPrimeFirst(currentActivationCodeInArray, nextActivationCodeInArray) {

        if (primeAppIds.indexOf(currentActivationCodeInArray.attributes.app) > -1
            && primeAppIds.indexOf(nextActivationCodeInArray.attributes.app) > -1) {

            sortActivationCodes(currentActivationCodeInArray, nextActivationCodeInArray);

        } else if (primeAppIds.indexOf(currentActivationCodeInArray.attributes.app) > -1) {

            return -1;

        } else if (primeAppIds.indexOf(nextActivationCodeInArray.attributes.app) > -1) {

            return 1;

        }
        return 0;

    },

    /**
     * @ngdoc function
     * @name processors.ActivationCodesProcessor#getAll
     * @methodOf processors.ActivationCodesProcessor
     * @function
     *
     * @description
     * This function can be used to return all processed activation codes.
     *
     * @returns {Array} all processed activation codes
     */
    getSortedActivationCodes() {

        return processedActivationCodes;

    },

    /**
    * @ngdoc function
    * @name processors.ActivationCodesProcessor#getObservable
    * @methodOf processors.ActivationCodesProcessor
    * @function
    *
    * @description
    * This function can be used to get an observable object for processed activation codes.
    * @returns {Object} an observable object for processed activation codes.
    */
    getObservable() {

        return observableProcessedActivationCodes;

    },

};

const subjectActiovationCodesRepository = ActivationCodesRepository.getObservable();

subjectActiovationCodesRepository.subscribe(
    data => ActivationCodesProcessor.onNext(data),
    () => { },
    () => { },
);

export default ActivationCodesProcessor;



// WEBPACK FOOTER //
// ./scripts/common/repositoryProcessors/-RFC.activationCodesProcessor.js